<template>
	<div class="order-body">
		<div class="fx-header">
			<p>操作日志</p>
		</div>
		<Search :AuthorityList='AuthorityList' ref="searchO" @handleSearch="handleSearch"/>
		<MainTable
			ref="maintable"
			:size='size'
			:page='page'
			:tableData='tableData'
			:totalCount='totalCount'
			:AuthorityList='AuthorityList'
			@handleSize='handleSizeChange'
			@handlePage='handlePageChange'
		/>
	</div>
</template>

<script>
import Search from '@/components/operationLog/Search.vue'
import MainTable from '@/components/operationLog/MainTable.vue'
export default {
	name: 'operationLog',
	components: {
		Search,
		MainTable
	},
	data () {
		return {
			AuthorityList: {
				'04_0002_0001_00': false,
				'04_0002_0002_00': false
			},
			page: 1,
			size: 20,
			tableData: [],
			totalCount: 0
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '7-3')
		let dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
		let searchParams = this.searchParamsChange({ dateValue: dateValue })
		this.getLogList(searchParams)
		// this.getLogList([])
		this.getAuthority('04_0002_0000_00')
	},
	methods: {
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			const searchO = this.$refs.searchO
			let searchParams = { dateValue: searchO.dateValue, operator: searchO.operator, tel: searchO.tel, operationObject: searchO.operationObject, operationType: searchO.operationType, operationDetail: searchO.operationDetail }
			searchParams = this.searchParamsChange(searchParams)
			this.getLogList(searchParams)
		},
		handlePageChange (value) {
			this.page = value
			const searchO = this.$refs.searchO
			let searchParams = { dateValue: searchO.dateValue, operator: searchO.operator, tel: searchO.tel, operationObject: searchO.operationObject, operationType: searchO.operationType, operationDetail: searchO.operationDetail }
			searchParams = this.searchParamsChange(searchParams)
			this.getLogList(searchParams)
		},
		handleSearch (searchParams) {
			console.log(searchParams)
			this.page = 1
			this.$refs.maintable.pagination.page = 1
			searchParams = this.searchParamsChange(searchParams)
			this.getLogList(searchParams)
		},
		searchParamsChange (searchParams) {
			if (!searchParams) {
				return
			}
			const condition = []
			if (searchParams.operationDetail) {
				const arr = {
					column_name: 'message',
					value: searchParams.operationDetail,
					eq: true
				}
				condition.push(arr)
			}
			if (searchParams.operator) {
				const arr = {
					column_name: 'userName',
					value: searchParams.operator,
					eq: true
				}
				condition.push(arr)
			}
			if (searchParams.tel) {
				const arr = {
					column_name: 'tel',
					value: searchParams.tel,
					like: true
				}
				condition.push(arr)
			}
			if (searchParams.operationObject) {
				const arr = {
					column_name: 'operationObject',
					value: searchParams.operationObject,
					eq: true
				}
				condition.push(arr)
			}
			if (searchParams.operationType) {
				const arr = {
					column_name: 'actionType',
					value: searchParams.operationType,
					eq: true
				}
				condition.push(arr)
			}
			if (searchParams.dateValue) {
				if (searchParams.dateValue[0]) {
					let date = searchParams.dateValue[0].replace(/-/g, '/')
					const arr = {
						column_name: '@timestamp',
						value: Date.parse(new Date(date)),
						ge: true
					}
					condition.push(arr)
				}
				if (searchParams.dateValue[1]) {
					let date = searchParams.dateValue[1].replace(/-/g, '/')
					const brr = {
						column_name: '@timestamp',
						value: Date.parse(new Date(date)),
						le: true
					}
					condition.push(brr)
				}
			}
			return condition
		},
		getLogList (searchParams) {
			// console.log(this.$fxLogger)
			// console.log(searchParams)
			const arr = {
				column_name: 'syscodeid',
				value: window.localStorage.getItem('syscodeid'),
				eq: true
			}
			const arr1 = {
				column_name: 'actionType',
				value: 'error',
				ne: true
			}
			const arr2 = {
				column_name: 'category',
				value: 'update',
				eq: true
			}
			searchParams.push(arr, arr1, arr2)
			const searchLogparams = {
				index: this.$fxLogger.config.index,
				page: this.page,
				pageSize: this.size,
				column: [
					'@timestamp',
					'sid',
					'message',
					'messageResult',
					'source',
					'userIp',
					'rootId',
					'pathId',
					'userName',
					'mainMenu',
					'subMenu',
					'actionType',
					'curName',
					'messageType',
					'uid',
					'trans',
					'tittle',
					'messageResultCause',
					'messageResultCause.message',
					'tel',
					'operationObject',
					'syscodeid',
					'category'
				],
				order_by: [
					{
						column_name: '@timestamp',
						asc: false
					}
				],
				condition: searchParams
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlSearcher}/search`,
				data: searchLogparams
			}).then(res => {
				if (res.type === 0) {
					res.data.forEach(e => {
						e['@timestamp'] = this.$fxUtils.setDateTime(new Date(e['@timestamp']))
					})
					this.tableData = res.data
					this.totalCount = +res.total
				} else {
					this.message.error(res.msg)
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body {
	flex: 1
	display flex
	flex-direction column
	.shop-position {
		display flex
		align-items: center
		height: 50px
		min-height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.order-menu {
		height: 50px
		display flex
		position relative
		border-bottom: 1px solid #dce1fe
		li {
			height: 100%
			line-height: 49px
			margin-right: 60px
			font-size: 15px
			// font-weight: 700
			box-sizing:border-box
			cursor: pointer
			position: relative
			color: #595959
			&.active {
				color: var(--fx-primary-color)
				border-bottom: 2px solid var(--fx-primary-color)
			}
			span {
				position: absolute;
				width: 18px;
				height: 18px;
				line-height: 18px;
				border-radius: 50%;
				font-size: 11px;
				top: 5px;
				right: -18px;
				text-align: center;
				background-color: #EC4141;
				color: #fff;
				&.big-num {
					width: 28px;
					border-radius: 40px;
					right: -28px;
				}
			}
		}
		div {
			height: 100%
			line-height: 49px
			font-size: 14px
			font-weight: 700
			box-sizing:border-box
			position absolute;
			top: 0;
			right: 50px;
		}
	}
}
</style>
<style lang="stylus">
.order-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
